import {all} from 'redux-saga/effects';

import {profileSagas} from 'store/profile';

import {affiliateSagas} from './affiliate/affiliate.sagas';
import analyticsSagas from './analytics/analytics.sagas';
import authSagas from './auth/auth.sagas';
import {contentSagas} from './content';
import marketsSagas from './markets/markets.sagas';
import offersSagas from './offers/offers.sagas';
import {propertySagas} from './properties';
import reservationsSagas from './reservations/reservations.sagas';
import {watchTargetTestsOnWindow} from './target/target.sagas';
import {paymentsSagas} from './payments/payments.sagas';

export default function* rootSaga() {
  return yield all([
    analyticsSagas(),
    propertySagas(),
    contentSagas(),
    offersSagas(),
    marketsSagas(),
    reservationsSagas(),
    watchTargetTestsOnWindow(),
    authSagas(),
    profileSagas(),
    affiliateSagas(),
    paymentsSagas(),
  ]);
}
